import type { AppSummary, DeploymentStatusSnapshot } from '../api';
import { appStatusPresentation } from '../appStatus';
import { useDeploymentStatuses } from '../useDeploymentStatuses';
import { Tag } from '../ds';

/** Catalog passes its batched history. Standalone About uses a one-app batch. */
export function AppStatusTag({ app, visible = true, size = 'default', history, unavailable = false }:
  { app: AppSummary; visible?: boolean; size?: 'sm' | 'default'; history?: DeploymentStatusSnapshot | null; unavailable?: boolean }) {
  const own = history === undefined;
  const statuses = useDeploymentStatuses(own && !app.archived ? [app.repo] : [], visible);
  const current = own ? statuses.histories[app.repo] : history;
  const failed = unavailable || (own && (statuses.unavailable.includes(app.repo) || statuses.denied.includes(app.repo)));
  const status = failed && !app.archived ? { label: 'Status unavailable', variant: 'default' as const } : appStatusPresentation(app, current?.runs);
  const checkedAt = current?.cache?.checkedAt;
  return <span role="status" aria-label="App status" style={{ display: 'inline-flex', flexDirection: 'column', gap: 4 }}>
    <Tag variant={status.variant} size={size}
      style={status.label === 'Infra request approved' ? { backgroundColor: '#FFEECD', color: '#AE7000' } : undefined}>{status.label}</Tag>
    {current?.cache?.stale && checkedAt && <small title={checkedAt}>Last checked {new Date(checkedAt).toLocaleTimeString()} · May be out of date</small>}
  </span>;
}
